export default {
  state: {
    exitEdition: false,
    exitEditionRoute: {}
  },

  getters: {
    getExitEdition (state) {
      return state.exitEdition
    },

    getExitEditionRoute (state) {
      return state.exitEditionRoute
    }
  },

  mutations: {

    setExitEdition (state, exitEdition) {
      state.exitEdition = exitEdition
    },

    setExitEditionRoute (state, exitEditionRoute) {
      state.exitEditionRoute = exitEditionRoute
    }
  }
}
